import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ITask, Task } from '../Tasks.ts';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function useGetTasks() {
    const { currentUser } = useSessionProvider();

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.tasks, currentUser?.selectedHealthcareFacilityID],
        queryFn: async () => {
            const result: ITask[] = await TasksApi.getTasks(
                currentUser?.selectedHealthcareFacilityID ?? undefined
            );
            return result ? result.map((x: ITask) => new Task(x)) : [];
        },
    });
}
